module.exports = __webpack_public_path__ + "img/underline-primary-faded.1995818.svg";